import React, { useState,  useContext, useRef } from 'react';
import './SelectedMI.css';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import MonitoredIndividualSelection from '../MonitoredIndividualSelection/MonitoredIndividualSelection';
import logComponent from '../../common/logComponent';
import MonitoredIndividualImage from '../MonitoredIndividualImage/MonitoredIndividualImage';

export default function SelectedMI({ onVisibilityChange  }) {
  const environmentContext = useContext(EnvironmentContext);
  const [monitoredIndividualSelectionVisible, setMonitoredIndividualSelectionVisible] = useState(false);
  const switchMonitoredIndividualBtnRef = useRef(null);
  const { activeUser: user, selectedMonitoredIndividual } = environmentContext;

  if (logComponent('SelectedMI')) { console.debug('SelectedMI rendered'); }

  const showMonitoredIndividualSelection = () => {
    if (logComponent('SelectedMI')) { console.debug('SelectedMI showMonitoredIndividualSelection'); }
    setMonitoredIndividualSelectionVisible(true);
    onVisibilityChange();
  }

  const hideMonitoredIndividualSelection = (triggeredByKeyboard) => {
    if (logComponent('SelectedMI')) { console.debug('SelectedMI hideMonitoredIndividualSelection'); }
    setMonitoredIndividualSelectionVisible(false);
    onVisibilityChange();

    if (triggeredByKeyboard && switchMonitoredIndividualBtnRef.current) switchMonitoredIndividualBtnRef.current.focus();
  }

  const getDisplayName = () => {
    if (logComponent('SelectedMI')) { console.debug('SelectedMI getDisplayName'); }

    return (
      selectedMonitoredIndividual.legalFirstName + ' ' +
      (selectedMonitoredIndividual.preferredName ? '(' + selectedMonitoredIndividual.preferredName + ') ' : '') +
      selectedMonitoredIndividual.lastName);
  }

  const getUnit = () => {
    if (logComponent('SelectedMI')) { console.debug('SelectedMI getUnit'); }

    if (!selectedMonitoredIndividual || !selectedMonitoredIndividual.monitoredIndividualUnits || 
        selectedMonitoredIndividual.monitoredIndividualUnits.length === 0) return;

    return selectedMonitoredIndividual?.monitoredIndividualUnits[0]?.unit?.name;
  }


  return (
    <React.Fragment>
      <div className="Selected-MI">
        <div className="Selected-MI__image">
          <MonitoredIndividualImage monitoredIndividual={selectedMonitoredIndividual} />
        </div>
        <div className="Selected-MI__info">
          <p className="Selected-MI__name">{getDisplayName()}</p>
          <p className="Selected-MI__unit">{getUnit()}</p>
          {
            user.MonitoredIndividualUsers && user.MonitoredIndividualUsers.length > 1 &&
            <button
              ref={switchMonitoredIndividualBtnRef}
              onClick={showMonitoredIndividualSelection}
              className="Selected-MI__switch-monitoredindividual">switch individual</button>
          }
        </div>
      </div>
      {
        monitoredIndividualSelectionVisible &&
        <MonitoredIndividualSelection hide={hideMonitoredIndividualSelection} />
      }
    </React.Fragment>
  );
}